import { CIcon } from '~/icons/types'

export const ciHealthBeautyMedicine: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21.565 13.156h-.8v-.418a2.292 2.292 0 0 0-2.24-2.336h-.38c1.2-2.1 1.162-4.564-.11-7.35a.931.931 0 0 0-.79-.55.92.92 0 0 0-.851.453A4.4 4.4 0 0 1 12 5.354c-5.34 0-6.35 3.69-6.541 5.05a2.292 2.292 0 0 0-2.22 2.334v.418h-.8a.95.95 0 0 0-.935.959v5.049A2.292 2.292 0 0 0 3.739 21.5h16.522a2.292 2.292 0 0 0 2.239-2.336v-5.05a.95.95 0 0 0-.935-.958ZM12 6.354a5.375 5.375 0 0 0 5.176-2.766c1.193 2.68 1.111 4.91-.226 6.814H6.458C6.635 9.215 7.526 6.354 12 6.354Zm-7.761 6.384a1.292 1.292 0 0 1 1.24-1.338h13.042a1.292 1.292 0 0 1 1.24 1.336v.418H4.239v-.416ZM21.5 19.164a1.292 1.292 0 0 1-1.239 1.336H3.739A1.292 1.292 0 0 1 2.5 19.164l-.065-5.008h1.318l16.32-.035a.488.488 0 0 0 .38 0H21.5v5.043Z'
    },
    {
      d:
        'M18.521 15H5.479a.5.5 0 0 0-.5.5V19a.5.5 0 0 0 .5.5h13.042a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5Zm-.5 3.5H5.979V16h12.042v2.5Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'health-beauty-medicine',
  type: 'thin'
}
